
  import '@webcomponents/scoped-custom-element-registry';
  import '@omicronenergy/oscd-shell/oscd-shell.js';
  import { plugins } from './plugins.js';

  customElements.whenDefined('oscd-shell').then(async () => {
    const editor = document.querySelector('oscd-shell');
    await editor.updateComplete;
    editor.plugins = plugins;

    const params = new URL(document.location).searchParams;
    for (const [name, value] of params) {
      editor.setAttribute(name, value);
    }
  });
